<template>
  <section class="why-choose-us-section">
    <div class="container-right">
      <div class="why-choose-us-section--inner">
        <div class="section-title-box">
          <h2 class="section-title">Этап работы</h2>
        </div>

        <div class="why-choose-us-tabs">
          <div v-for="tab in workStages" :key="tab.id" class="why-choose-us-tab">
            <button type="button" class="why-choose-us-tab__link" :class="{ active: selectedTab === tab.title }"
              @click.prevent="openSelectedTab(tab.title)">
              {{ tab.title }}
            </button>

            <transition name="fade-up">
              <div v-if="selectedTab === tab.title" class="why-choose-us-tab__item">
                <div class="main-content">
                  <div class="main-content__info-box">
                    <h2 class="main-content__info-box-title">{{ tab.title }}</h2>
                    <p v-html="tab.content"></p>
                  </div>
                  <div class="main-content__img-box">
                    <image-wrap class="why-choose-us-img" :image="tab.main_image" size="large" />
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const selectedTab = ref(null)
const workStages = ref([])

function openSelectedTab(val) {
  selectedTab.value = selectedTab.value === val ? null : val
}

async function getWorkStages() {
  const { data } = await axios.get('/get-work-stages')
  workStages.value = data.workStages
}
onMounted(getWorkStages)
</script>

<style scoped>
.why-choose-us-section {
  padding: 60px 20px;
  background: #f5f7fa;
}

.why-choose-us-section--inner {
  /* max-width: 1200px; */
  margin: 0 auto;
}

.container-right {
  max-width: none;
}


.why-choose-us-section--inner {
  display: flex;
  flex-wrap: wrap;
}

.section-title-box {
  flex: 0 0 380px;
  padding-right: 56px;

  @media screen and (max-width: 1024px) {
    flex: 0 0 100%;
  }
}

.why-choose-us-tabs {
  counter-reset: tab-list;
  flex: 1;
  display: block;
}

.why-choose-us-tab {
  &:not(:first-child) {
    .why-choose-us-tab__link {
      border-top: 3px solid $color-primary;

    }
  }

  &:last-child {
    border-bottom: 3px solid $color-primary;
  }

  .why-choose-us-tab__link {
    font-family: var(--font-primary);
    font-size: 36px;
    color: $bg-header-footer-color;
    display: flex;
    padding-top: 34px;
    padding-bottom: 34px;
    width: 100%;
    transition: color .2s ease;

    @media screen and (max-width: 1024px) {
      padding-top: 24px;
      padding-bottom: 24px;
      font-size: 24px;
    }

    @media screen and (max-width: 768px) {
      padding-top: 16px;
      padding-bottom: 16px;
      font-size: 16px;
    }

    &::before {
      counter-increment: tab-list;
      content: counter(tab-list, decimal-leading-zero);
      font-size: 16px;
      margin-right: 40px;
      transition: color .2s ease;

      @media screen and (max-width: 1024px) {
        font-size: 14px;
        margin-right: 32px;
      }

      @media screen and (max-width: 768px) {
        font-size: 10px;
        margin-right: 20px;
      }
    }

    &.active {
      color: #fff;
    }
  }
}

.section-title-box {
  text-align: center;
  margin-bottom: 40px;
}

.section-title {
  font-size: 36px;
  font-weight: 800;
  color: #2c3e50;
  position: relative;
}

.section-title::after {
  content: "";
  display: block;
  width: 60px;
  height: 4px;
  background-color: #e8cc0f;
  margin: 12px auto 0;
  border-radius: 2px;
}

.why-choose-us-tab {
  margin-bottom: 24px;
}

.why-choose-us-tab__link {
  background: #fff;
  color: #3c5757;
  padding: 14px 20px;
  border: 2px solid transparent;
  border-radius: 12px;
  font-weight: 600;
  font-size: 18px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 12px;
}

.why-choose-us-tab__link:hover {
  background-color: #e8cc0f1a;
}

.why-choose-us-tab__link.active {
  border-color: #e8cc0f;
  background: #fffbe6;
  color: #2c3e50 !important;
}

.why-choose-us-tab__item {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 30px;
  margin-top: 20px;
}

.main-content {
  display: flex;
  gap: 30px;
  align-items: center;
  flex-direction: column;
}

.main-content__info-box {
  flex: 1;
}

.main-content__info-box-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #34495e;
}

.main-content__info-box p {
  font-size: 16px;
  line-height: 1.6;
  color: #555;
}

.main-content__img-box {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.why-choose-us-img {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  object-fit: cover;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-up-enter-from,
.fade-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

@media screen and (max-width: 768px) {
  .why-choose-us-tab__item {
    padding: 10px;
  }

  .main-content {
    padding: 2px;
    flex-direction: column;
  }

  .main-content__img-box,
  .main-content__info-box {
    width: 100%;
  }

  .main-content__info-box-title {
    text-align: center;
  }
}
</style>